/* eslint-disable */
import React, { Component } from 'react';
import noImage from '../tools/auto/no-image.jpeg';
import axios from 'axios';
import { inject } from 'mobx-react';
import PracticeSetup from './auto/PracticeSetup';
import confetti from 'canvas-confetti';
import { RingLoader } from 'react-spinners';
import VideoExplanations from './auto/InfinitePractice/VideoExplanation';
import DottedStepper from './auto/DottedStepper';
import ApiStore from '../api/ApiStore';

@inject('store')
class InfinitePractice extends Component {
  constructor(props) {
    super(props);
    const licenseType = props.licenseType || 'permiso_b';

    this.state = {
      isLoading: true,
      timer: 0,
      questionData: null,
      selectedAnswer: null,
      showResult: false,
      chaptersData: [],
      overallPerformance: 0,
      answeringEnabled: true,
      pomodoroTimer: 25 * 60,
      restingTimer: 5 * 60,
      pomodoroRunning: true,
      restingRunning: false,
      licenseType,
      setupComplete: false,
      questionIds: props.questionIds || [],
      currentQuestionIndex: 0,
      streak: 0,
      showSnackbar: false,
      snackbarMessage: '',
      isChapterGridExpanded: false,

      currentLevel: 1,
      levelName: '',
      unifiedProgress: 0,
      progressDetails: {},
      advancementCriteria: {},

      // Fallback level tracking
      usingFallbackLevel: false,
      fallbackLevel: null,
      actualLevel: null,

      completionPercentage: 0,
      showChapterGrid:
        props.showChapterGrid !== undefined ? props.showChapterGrid : true,
      showLevelCompletionModal: false,
      isGeneratingPodcast: false,
      podcastUrl: null,
      mostFailedQuestions: [],

      podcastError: false,
      podcastEnabled: false,

      // NEW: Track how many questions have been answered
      answeredCount: 0,

      // For responsive UI
      isProgressExpanded: false, // Always start collapsed regardless of screen size

      // Sound settings
      soundsEnabled: true, // Sounds are enabled by default
    };

    // Sounds
    this.bellSound = new Audio('/bell.mp3');
    this.bellSound.load();
    this.bellSound.onerror = e => console.error('Bell sound error:', e);

    this.successSoundPaths = [
      '/sounds/success1.mp3',
      '/sounds/success2.mp3',
      '/sounds/success3.mp3',
      '/sounds/success4.mp3',
      '/sounds/success5.mp3',
      '/sounds/success6.mp3',
      '/sounds/success7.mp3',
      '/sounds/success8.mp3',
      '/sounds/success9.mp3',
      '/sounds/success10.mp3',
      '/sounds/success11.mp3',
      '/sounds/success12.mp3',
      '/sounds/success13.mp3',
      '/sounds/success14.mp3',
      '/sounds/success15.mp3',
      '/sounds/success16.mp3',
      '/sounds/success17.mp3',
      '/sounds/success18.mp3',
    ];
    this.successSounds = [];
    this.initializeSounds();

    this.successMessages = [
      '¡Nivel desbloqueado! 🚀 Has alcanzado nuevas alturas. ¡Tómate un momento para celebrar!',
      '¡Bravo! Eres un auténtico maestro. 🦸‍♂️ Tu esfuerzo ha dado frutos. ¡Sigue así!',
      '¿Escuchas eso? 🎶 Es el sonido de la victoria. ¡Que siga la fiesta!',
      '¡Uh, uh! Nivel desbloqueado como un ninja! 🥷',
      '¡Mira tú! Eres como un Pokémon en evolución. 🐉',
      '¡Estás a un paso de la cima! ⛰️',
      '¡Sí, lo hiciste! 🎯 ¡El próximo nivel te espera con los brazos abiertos!',
    ];
  }

  initializeSounds() {
    this.successSoundPaths.forEach(path => {
      const sound = new Audio(path);
      sound.load();
      sound.onerror = e => console.error(`Error loading sound ${path}:`, e);
      this.successSounds.push(sound);
    });
  }

  shuffleQuestionIds = () => {
    const { questionIds } = this.state;
    for (let i = questionIds.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [questionIds[i], questionIds[j]] = [questionIds[j], questionIds[i]];
    }
    this.setState({ questionIds, currentQuestionIndex: 0 });
  };

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
    this.shuffleQuestionIds();
    // Removed fetchTopicPerformance() here to avoid heavy DB load at init
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchTopicPerformance = async () => {
    try {
      const organizationName = this.props.store.profile.organization;
      const licenseType = this.state.licenseType || 'permiso_b';

      // Use the new API endpoint for fetching user topic performance
      // This is now handled through the evaluateLevelAuto call which returns topic performance
      const levelInfo = await ApiStore.evaluateLevelAuto(
        licenseType,
        organizationName
      );

      if (levelInfo && levelInfo.topic_performance) {
        const chaptersData = Object.entries(levelInfo.topic_performance).map(
          ([name, accuracy]) => ({
            name,
            accuracy,
          })
        );

        this.setState({
          chaptersData,
          overallPerformance: levelInfo.overall_performance || 0,
        });
      }
    } catch (error) {
      console.error('Error fetching topic performance:', error);
    }
  };

  async evaluateLevel(silent = false) {
    try {
      const licenseType = this.state.licenseType || 'permiso_b';
      const response = await ApiStore.evaluateLevelAuto(
        licenseType,
        this.props.store.profile.organization
      );

      let currentLevel = response.current_level;
      let completionPercentage = response.completion_percentage;

      // Extract new progress metrics from API response
      const levelName = response.level_name || '';
      const unifiedProgress = response.unified_progress || 0;
      const progressDetails = response.progress_details || {};
      const advancementCriteria = response.advancement_criteria || {};

      // Only ensure we don't go below level 1
      if (currentLevel < 1) {
        currentLevel = 1;
      }

      console.log(
        `Evaluating level: ${this.state.currentLevel} → ${currentLevel}`
      );
      console.log(`Unified progress: ${unifiedProgress}%`);

      // Check if we advanced from our previous level
      if (currentLevel > this.state.currentLevel && !silent) {
        console.log(
          `Level advancement detected: ${this.state.currentLevel} → ${currentLevel}`
        );

        // Store the just-completed level (previous level)
        const completedLevel = this.state.currentLevel;

        // Update state with new level first
        this.setState({
          currentLevel,
          levelName,
          unifiedProgress,
          progressDetails,
          advancementCriteria,
          completionPercentage,
        });

        // Trigger effects
        this.triggerSuccessEffects();
        this.setState({
          showLevelCompletionModal: true,
          podcastError: false, // Reset podcast error state
        });

        // Generate podcast for the completed level
        this.handleLevelCompletion(completedLevel);
      } else {
        // Otherwise, just set it
        this.setState({
          currentLevel,
          levelName,
          unifiedProgress,
          progressDetails,
          advancementCriteria,
          completionPercentage,
        });
      }
    } catch (error) {
      console.error('Error evaluating level:', error);
    }
  }

  /**
   * Generate podcasts for ANY completed level
   * (Now includes level 1, 2, or 3)
   */
  handleLevelCompletion = async completedLevel => {
    try {
      const licenseType = this.state.licenseType || 'permiso_b';
      // We won't skip any level; let's always attempt a podcast
      const response = await ApiStore.checkPodcastNeed(
        licenseType,
        completedLevel,
        this.props.store.profile.organization
      );

      // According to API docs, the response should have podcast_generation_enabled and podcast_already_generated
      const { podcast_generation_enabled, podcast_already_generated } =
        response;

      // Set podcast enabled state for the modal
      this.setState({ podcastEnabled: podcast_generation_enabled });

      if (!podcast_generation_enabled) {
        console.log(
          `Podcast generation not enabled for level ${completedLevel}. Skipping generation.`
        );
        return;
      }

      // Log complete response for debugging
      console.log(
        `Podcast check response for level ${completedLevel}:`,
        response
      );

      if (podcast_already_generated) {
        console.log(
          `Podcast already generated for level ${completedLevel}. Skipping.`
        );
        return;
      }

      // If we reach here, it means podcast is required and not generated yet
      const failedQuestions = await ApiStore.getMostFailedQuestions({
        limit: 3,
        level: completedLevel,
        exclude_no_explanation_or_video: true,
        organization_name: this.props.store.profile.organization,
      });

      // Check if we actually have failed questions, if not, skip podcast generation
      if (
        !failedQuestions.questions ||
        failedQuestions.questions.length === 0
      ) {
        console.log(
          `No failed questions found for level ${completedLevel}. Skipping podcast generation.`
        );
        // Update modal message to indicate no podcast will be generated
        this.setState({
          showLevelCompletionModal: true,
          podcastError: true,
        });
        return;
      }

      this.setState({ mostFailedQuestions: failedQuestions.questions });

      // Get application name from store or use a default
      const applicationName = this.props.store?.applicationName || 'Virtus';

      console.log('Using application name:', applicationName);

      const scriptData = {
        organization_name: this.props.store.profile.organization,
        application_name: applicationName,
        model: 'claude-3-7-sonnet-20250219',
        topic: `"Las preguntas proporcionadas son las preguntas en las que el alumno, ${
          this.props.store.profile.username
        }, ha encontrado más problemas durante el Nivel ${completedLevel}. Simula una revisión detallada de estas preguntas y sus respuestas correctas enfocada a ayudar a ${
          this.props.store.profile.username
        } a afianzar sus conocimientos. Ocasionalmente, añade un toque de humor para ayudar al alumno a acordarse de un concepto."`,
        tone: 'Académico y amigable',
        minutes: 5,
        question_ids: failedQuestions.questions.map(q => q.QuestionID),
        language: 'spanish',
        level: `${completedLevel}`,
      };

      const scriptResponse = await ApiStore.generatePodcastScript(scriptData);

      const podcastData = {
        ...scriptData,
        script: scriptResponse.script,
      };

      // Just initiate the podcast generation without polling - backend will handle it
      await ApiStore.generatePodcast(podcastData);

      this.setState({
        isGeneratingPodcast: false,
      });
    } catch (error) {
      console.error('Error handling level completion:', error);
      this.setState({
        isGeneratingPodcast: false,
        podcastError: true,
      });

      // Show error message to user
      this.showSnackbar(
        'Error al generar el podcast. Inténtalo de nuevo más tarde.'
      );
    }
  };

  handleSetupComplete = ({
    licenseType,
    pomodoroTime,
    restingTime,
    currentLevel,
    completionPercentage,
    soundsEnabled,
  }) => {
    this.setState(
      {
        licenseType,
        pomodoroTime,
        restingTime,
        pomodoroTimer: pomodoroTime * 60,
        restingTimer: restingTime * 60,
        setupComplete: true,
        // Only enforce minimum level of 1, don't clamp maximum
        currentLevel: Math.max(1, currentLevel || 1),
        completionPercentage: completionPercentage || 0,
        soundsEnabled: soundsEnabled !== undefined ? soundsEnabled : true,
      },
      () => {
        this.shuffleQuestionIds();
        this.loadNextQuestion();
        // Evaluate level immediately after setup to get all progress metrics
        this.evaluateLevel(true);
      }
    );
  };

  tick() {
    const {
      pomodoroTimer,
      pomodoroRunning,
      restingTimer,
      restingRunning,
      setupComplete,
    } = this.state;

    if (!setupComplete) {
      return;
    }

    // Pomodoro countdown
    if (pomodoroRunning && pomodoroTimer > 0) {
      this.setState({
        pomodoroTimer: pomodoroTimer - 1,
        timer: this.state.timer + 1,
      });

      if (pomodoroTimer - 1 === 0) {
        this.playBellSound();
        this.setState({ pomodoroRunning: false, restingRunning: true });
      }
    }

    // Rest countdown
    if (restingRunning && restingTimer > 0) {
      this.setState({
        restingTimer: restingTimer - 1,
      });

      if (restingTimer - 1 < 0) {
        this.playBellSound();
        this.setState({ restingRunning: false });
        alert("Break's over! Time to get back to practice.");
        this.resetPomodoroTimer();
      }
    }
  }

  playBellSound() {
    if (this.bellSound && this.state.soundsEnabled) {
      this.bellSound.play().catch(error => {
        console.error('Error playing bell sound:', error);
      });
    }
  }

  resetPomodoroTimer() {
    const { pomodoroTime, restingTime } = this.state;
    this.setState(
      {
        pomodoroTimer: pomodoroTime * 60,
        pomodoroRunning: true,
        restingTimer: restingTime * 60,
      },
      this.loadNextQuestion
    );
  }

  loadNextQuestion = async () => {
    this.setState({
      isLoading: true,
      nextQuestionAvailable: false,
      showResult: false,
      selectedAnswer: null,
      answeringEnabled: true,
      isProgressExpanded: false, // Collapse the progress dashboard when loading next question
    });

    try {
      // Evaluate level - no longer clamping to maximum
      await this.evaluateLevel();

      const { questionIds, currentQuestionIndex, currentLevel } = this.state;
      const organizationName = this.props.store.profile.organization;
      const licenseType = this.state.licenseType || 'permiso_b';

      // If level is higher than max content level, use the highest available level for questions
      // This prevents API errors but still shows the user their true level
      let contentLevel = currentLevel;

      // Track whether we're using the actual level or a fallback
      this.setState({ usingFallbackLevel: false });

      // Log the level being used for content
      console.log(`Using level ${contentLevel} for question content`);

      let response;
      if (questionIds.length > 0) {
        // If we have questionIds from props or setup
        const questionId = questionIds[currentQuestionIndex];
        // Use new API endpoint for fetching a specific question
        response = await ApiStore.getNextQuestionAuto(
          licenseType,
          organizationName,
          contentLevel
        );
      } else {
        // Otherwise, fetch from the new v1 endpoint with currentLevel
        response = await ApiStore.getNextQuestionAuto(
          licenseType,
          organizationName,
          contentLevel
        );
      }

      const {
        question_id,
        text,
        explanation,
        options,
        correct_answer,
        image_data,
        video_ranges,
      } = response.data;

      const answers = Object.entries(options)
        .filter(([_, val]) => val)
        .map(([key, val]) => ({
          text: val,
          isCorrect: key === correct_answer,
        }));

      const imageSrc = image_data
        ? `data:image/png;base64,${image_data}`
        : noImage;

      this.setState(prevState => ({
        questionData: {
          questionId: question_id,
          question: text,
          image: imageSrc,
          answers,
          explanation,
          videoRanges: video_ranges,
        },
        isLoading: false,
        currentQuestionIndex:
          questionIds.length > 0
            ? (prevState.currentQuestionIndex + 1) % questionIds.length
            : 0,
      }));
    } catch (error) {
      console.error('Error loading question:', error);
      // If there was an error loading questions, try falling back to level 3
      if (this.state.currentLevel > 3) {
        console.log(
          'Error loading question with current level, trying with level 3'
        );

        // Store the previous level for reference
        const previousLevel = this.state.currentLevel;

        try {
          const organizationName = this.props.store.profile.organization;
          const licenseType = this.state.licenseType || 'permiso_b';

          // Update progressDetails to show 100% completion for the previous level
          const updatedProgressDetails = { ...this.state.progressDetails };

          // Show 100% completion for the previous level in progress dashboard
          // and track that we're using a fallback level
          this.setState({
            progressDetails: updatedProgressDetails,
            unifiedProgress: 100, // Set to 100% for congruency
            usingFallbackLevel: true,
            fallbackLevel: 3, // Store the fallback level (3)
            actualLevel: previousLevel, // Store the actual level
          });

          const response = await ApiStore.getNextQuestionAuto(
            licenseType,
            organizationName,
            3 // Fallback to level 3
          );

          const {
            question_id,
            text,
            explanation,
            options,
            correct_answer,
            image_data,
            video_ranges,
          } = response.data;

          const answers = Object.entries(options)
            .filter(([_, val]) => val)
            .map(([key, val]) => ({
              text: val,
              isCorrect: key === correct_answer,
            }));

          const imageSrc = image_data
            ? `data:image/png;base64,${image_data}`
            : noImage;

          this.setState(prevState => ({
            questionData: {
              questionId: question_id,
              question: text,
              image: imageSrc,
              answers,
              explanation,
              videoRanges: video_ranges,
            },
            isLoading: false,
          }));

          return;
        } catch (fallbackError) {
          console.error('Error with fallback question loading:', fallbackError);
        }
      }

      this.setState(
        { isLoading: false, questionData: null },
        this.evaluateLevel
      );
    }
  };

  handleAnswerSelection = async answer => {
    if (!this.state.answeringEnabled) return;

    const { questionData } = this.state;
    const organizationName = this.props.store.profile.organization;
    this.setState({
      selectedAnswer: answer,
      showResult: true,
      nextQuestionAvailable: true,
      answeringEnabled: false,
      isProgressExpanded: false, // Collapse the progress dashboard when an answer is selected
    });

    try {
      // Submit answer using the new v1 API endpoint
      await ApiStore.answerQuestionAuto(
        questionData.questionId,
        answer.isCorrect,
        organizationName
      );
    } catch (error) {
      console.error('Error submitting answer:', error);
    }

    // If correct, add to streak
    if (answer.isCorrect) {
      const newStreak = this.state.streak + 1;
      this.setState({ streak: newStreak });

      // Confetti/sound every 3 correct in a row
      if (newStreak % 3 === 0) {
        this.triggerSuccessEffects();
        this.showSnackbar(
          `¡Excelente! Has respondido ${newStreak} preguntas seguidas correctamente.`
        );
      }
    } else {
      // Reset streak
      this.setState({ streak: 0 });
    }

    // Now increment answeredCount and conditionally fetch performance
    this.setState(
      prevState => {
        const newCount = prevState.answeredCount + 1;
        return { answeredCount: newCount };
      },
      async () => {
        // After answeredCount is updated, check if we hit a multiple of 20
        if (this.state.answeredCount % 20 === 0) {
          await this.fetchTopicPerformance();
        }

        // Scroll smoothly to the bottom of the page
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth',
        });
      }
    );
  };

  showSnackbar = message => {
    this.setState({ showSnackbar: true, snackbarMessage: message });
    setTimeout(() => {
      this.setState({ showSnackbar: false, snackbarMessage: '' });
    }, 6000);
  };

  triggerSuccessEffects = () => {
    if (this.state.soundsEnabled) {
      const randomIndex = Math.floor(Math.random() * this.successSounds.length);
      const randomSound = this.successSounds[randomIndex];
      randomSound.load();
      randomSound.play().catch(error => {
        console.error('Error playing success sound:', error);
      });
    }

    confetti({
      particleCount: 200,
      spread: 80,
      origin: { y: 0.95 },
    });
  };

  toggleSounds = () => {
    this.setState(
      prevState => ({
        soundsEnabled: !prevState.soundsEnabled,
      }),
      () => {
        this.showSnackbar(
          this.state.soundsEnabled
            ? 'Sonidos activados'
            : 'Sonidos desactivados'
        );
      }
    );
  };

  handleSkipRest = () => {
    this.setState({ restingRunning: false });
    this.resetPomodoroTimer();
  };

  formatTime(seconds) {
    if (seconds <= 0) return '00:00:00';
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  }

  renderQuestion = () => {
    const {
      questionData,
      selectedAnswer,
      showResult,
      answeringEnabled,
      streak,
    } = this.state;

    return (
      <div className="md:grid md:grid-cols-2 gap-4 items-start">
        <div className="flex flex-col justify-start">
          <div>
            <h2 className="font-semibold text-lg mb-2">
              {questionData.question}
            </h2>
          </div>
          <div className="text-center mb-5">
            <span className="font-bold text-xl">
              Aciertos seguidos: {streak}
            </span>
          </div>
          {questionData.answers.map((answer, index) => (
            <button
              key={index}
              onClick={() => this.handleAnswerSelection(answer)}
              disabled={!answeringEnabled}
              className={`font-bold py-2 px-4 rounded-full mb-2 w-full text-left transition-all duration-300
                ${
                  showResult
                    ? selectedAnswer === answer
                      ? answer.isCorrect
                        ? 'bg-green-500 hover:bg-green-600 text-white animate-pulse'
                        : 'bg-red-500 hover:bg-red-600 text-white'
                      : 'bg-gray-200 hover:bg-gray-300'
                    : 'bg-gray-200 hover:bg-gray-300'
                }`}
            >
              {answer.text}
            </button>
          ))}
        </div>
      </div>
    );
  };

  renderProgressCircle = () => {
    const { unifiedProgress } = this.state;
    const radius = 90;
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = `${(circumference * unifiedProgress) / 100} ${circumference}`;

    return (
      <div className="progress-circle-container flex justify-center items-center my-4">
        <svg
          className="progress-circle"
          width="200"
          height="200"
          viewBox="0 0 200 200"
        >
          <circle
            className="progress-circle-bg"
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="10"
          />
          <circle
            className="progress-circle-fill"
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#3b82f6"
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            transform="rotate(-90 100 100)"
          />
          <text
            className="progress-text"
            x="100"
            y="100"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#333"
            fontSize="28"
            fontWeight="bold"
          >
            {Math.round(unifiedProgress)}%
          </text>
        </svg>
      </div>
    );
  };

  renderProgressDetails = () => {
    const {
      progressDetails,
      advancementCriteria,
      levelName,
      currentLevel,
      isProgressExpanded,
      usingFallbackLevel,
      fallbackLevel,
      actualLevel,
    } = this.state;

    if (!progressDetails || Object.keys(progressDetails).length === 0) {
      return null;
    }

    const criteriaItems = [
      {
        name: 'Intentos',
        value: progressDetails.questions_attempted || 0,
        required: progressDetails.required_attempts || 0,
        met: advancementCriteria?.attempts_met,
        icon: '📝',
      },
      {
        name: 'Precisión',
        value: `${(progressDetails.accuracy_percentage || 0).toFixed(1)}%`,
        required: `${(progressDetails.required_accuracy || 0).toFixed(1)}%`,
        met: advancementCriteria?.accuracy_met,
        icon: '🎯',
      },
      {
        name: 'Completado',
        value: `${progressDetails.questions_attempted || 0} / ${progressDetails.total_questions || 100}`,
        required: `${(progressDetails.required_completion || 0).toFixed(1)}%`,
        met: advancementCriteria?.completion_met,
        icon: '📈',
      },
      {
        name: 'Racha correcta',
        value: this.state.streak,
        met: advancementCriteria?.streak_met,
        icon: '🔥',
      },
      {
        name: 'Estudio espaciado',
        met: advancementCriteria?.spaced_review_met,
        icon: '📅',
      },
    ];

    // Toggle progress expansion for mobile responsiveness
    const toggleProgressExpansion = () => {
      this.setState({ isProgressExpanded: !isProgressExpanded });
    };

    // Determine which level to display in the header
    const displayLevel = usingFallbackLevel ? actualLevel : currentLevel;

    // Determine if all levels are completed (when we're using a fallback level)
    const allLevelsCompleted = usingFallbackLevel;

    return (
      <div className="rounded-lg">
        {/* Header - Always visible, same height as app header */}
        <div
          className="bg-white px-4 py-1 rounded-lg flex items-center shadow-sm justify-between cursor-pointer h-[56px]"
          onClick={toggleProgressExpansion}
        >
          <div className="flex items-center">
            <h2 className="font-bold text-gray-800 mr-2 text-base sm:text-lg">
              {allLevelsCompleted
                ? 'Niveles Completados'
                : `Nivel ${displayLevel}`}
            </h2>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-24 sm:w-32">
              <DottedStepper currentStep={displayLevel} maxSteps={3} />
            </div>
            <div className="bg-blue-100 text-blue-800 font-bold py-1 px-3 rounded-full text-xs sm:text-sm">
              {Math.round(this.state.unifiedProgress)}%
            </div>
            <span className="text-gray-400 text-sm">
              {isProgressExpanded ? '▲' : '▼'}
            </span>
          </div>
        </div>

        {/* Expandable content */}
        <div
          className={`bg-white p-6 rounded-b-lg transition-all duration-300 overflow-hidden ${
            isProgressExpanded
              ? 'max-h-[1000px] opacity-100 mt-2'
              : 'max-h-0 opacity-0'
          }`}
        >
          <div className="text-center mb-4">
            <p className="text-gray-600">Tu progreso en este nivel</p>
          </div>

          {this.renderProgressCircle()}

          {/* <div className="mt-6">
            <h3 className="text-lg font-semibold mb-3">Criterios de avance</h3>
            <div className="space-y-2">
              {criteriaItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-2 bg-gray-50 rounded-lg"
                >
                  <div className="flex items-center">
                    <span className="text-2xl mr-2">{item.icon}</span>
                    <span className="font-medium">{item.name}</span>
                  </div>
                  <div className="flex items-center">
                    {item.value && (
                      <span className="text-gray-700 mr-2">{item.value}</span>
                    )}
                    {item.required && (
                      <span className="text-gray-500 text-sm">
                        / {item.required}
                      </span>
                    )}
                    <span className="ml-2 text-lg">
                      {item.met ? '✅' : '⏳'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          {this.renderNextSteps()}

          {/* Show different podcast messages based on whether we're in fallback mode */}
          {advancementCriteria?.podcast_required && (
            <div className="mt-4 p-3 bg-blue-50 text-blue-700 rounded-lg">
              <p className="flex items-center">
                <span className="text-xl mr-2">🎧</span>
                {allLevelsCompleted
                  ? 'Recuerda revisar la galeria de Podcasts personalizados para ti'
                  : 'Al finalizar el nivel, nuestras IAs te ayudarán a reforzar los contenidos en un nuevo Podcast'}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderNextSteps = () => {
    const { unifiedProgress, advancementCriteria } = this.state;

    if (!advancementCriteria || Object.keys(advancementCriteria).length === 0) {
      return null;
    }

    if (unifiedProgress >= 100) {
      return (
        <div className="mt-6 p-4 bg-green-50 text-green-700 rounded-lg text-center">
          <p className="font-bold text-lg">
            ¡Felicidades! Has completado el nivel.
          </p>
        </div>
      );
    }

    const nextSteps = [];

    if (!advancementCriteria.completion_met) {
      nextSteps.push(
        'Contesta más preguntas para aumentar tu porcentaje de finalización'
      );
    }

    if (!advancementCriteria.accuracy_met) {
      nextSteps.push('Sigue practicando para mejorar tu precisión');
    }

    if (!advancementCriteria.streak_met) {
      nextSteps.push('Intenta conseguir más respuestas correctas consecutivas');
    }

    if (nextSteps.length === 0) {
      return null;
    }

    return (
      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <h3 className="font-bold text-blue-800 mb-2">
          Próximos pasos para avanzar
        </h3>
        <ul className="list-disc pl-5 space-y-1">
          {nextSteps.map((step, index) => (
            <li key={index} className="text-blue-700">
              {step}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  renderChaptersGrid = () => {
    const { chaptersData, currentLevel, overallPerformance } = this.state;
    return (
      <div
        className="relative"
        onMouseEnter={() => this.setState({ isChapterGridExpanded: true })}
        onMouseLeave={() => this.setState({ isChapterGridExpanded: false })}
      >
        {/* We assume your DottedStepper can handle up to 3 steps */}
        <DottedStepper currentStep={currentLevel} maxSteps={3} />
        <div className="cursor-pointer text-center py-2 bg-gray-200 rounded-t-lg">
          <span className="font-bold">
            {overallPerformance === 0
              ? '---'
              : `${Math.round(overallPerformance)}% aciertos`}
          </span>
          <span className="ml-2">
            {this.state.isChapterGridExpanded ? '▲' : '▼'}
          </span>
        </div>
        <div
          className={`overflow-hidden transition-all duration-300 ${
            this.state.isChapterGridExpanded ? 'max-h-96' : 'max-h-0'
          }`}
        >
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 p-4 bg-white rounded-b-lg">
            {chaptersData.map((chapter, index) => (
              <div
                key={index}
                className={`p-2 rounded-lg text-center transition-all duration-300
                  ${
                    chapter.accuracy === 0
                      ? 'bg-gray-50 text-gray-500'
                      : chapter.accuracy < 60
                        ? 'bg-red-50 text-red-700'
                        : chapter.accuracy > 90
                          ? 'bg-green-50 text-green-700'
                          : 'bg-blue-50 text-gray-700'
                  }`}
              >
                <div className="font-bold">{chapter.name}</div>
                <span className="text-sm">
                  {chapter.accuracy === 0
                    ? 'Sin intentos'
                    : `${Math.round(chapter.accuracy)}%`}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  renderLevelCompletionModal = () => {
    const { currentLevel, podcastError, unifiedProgress, podcastEnabled } =
      this.state;
    const completedLevel = currentLevel - 1;

    // Randomly select a success message from our list
    const randomSuccessMessageIndex = Math.floor(
      Math.random() * this.successMessages.length
    );
    const successMessage = this.successMessages[randomSuccessMessageIndex];

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-8 max-w-md w-full">
          <div className="text-center mb-6">
            <div className="inline-block bg-blue-500 text-white rounded-full p-3 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-1">¡Nivel Completado!</h2>
            <p className="text-gray-600">
              Has superado el nivel {completedLevel}
            </p>
          </div>

          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <p className="text-blue-800 font-medium">{successMessage}</p>
          </div>

          {podcastEnabled && (
            <div>
              {podcastError ? (
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="flex items-start">
                    <span className="text-2xl mr-2">📊</span>
                    <p className="text-sm text-gray-600">
                      No tenemos suficientes datos sobre tus preguntas falladas
                      en este nivel para generar un podcast. ¡Sigue practicando
                      y pronto tendrás uno!
                    </p>
                  </div>
                </div>
              ) : (
                <div className="bg-green-50 rounded-lg p-4 mb-4">
                  <div className="flex items-start">
                    <span className="text-2xl mr-2">🎧</span>
                    <p className="text-sm text-gray-700">
                      Estamos preparando un podcast personalizado donde
                      reforzaremos aquellas preguntas que más has fallado.
                      Estará disponible en tu sección de Podcasts en unos
                      minutos.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          <button
            className="w-full mt-4 bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded-md transition duration-300"
            onClick={() =>
              this.setState({
                showLevelCompletionModal: false,
                podcastError: false,
                podcastEnabled: false,
              })
            }
          >
            Continuar Practicando
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      isLoading,
      questionData,
      selectedAnswer,
      showResult,
      timer,
      pomodoroTimer,
      restingTimer,
      pomodoroRunning,
      restingRunning,
      showSnackbar,
      snackbarMessage,
      streak,
      setupComplete,
      nextQuestionAvailable,
    } = this.state;

    if (!setupComplete) {
      return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-75 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full m-4">
            <PracticeSetup onSetupComplete={this.handleSetupComplete} />
          </div>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
          <RingLoader color="#000000" size="120px" />
        </div>
      );
    }

    if (!questionData) {
      return <div>No hay preguntas disponibles.</div>;
    }

    const hasImage = questionData.image !== noImage;

    return (
      <div className="bg-gray-100 p-4 md:p-8 w-full h-full">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <header className="bg-white rounded-lg shadow-sm px-4 py-3 h-[56px] mb-6 flex justify-between items-center">
            <div className="text-xl font-bold text-gray-800">
              Práctica Infinita
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={this.toggleSounds}
                className={`flex items-center justify-center p-2 rounded-full transition-colors ${this.state.soundsEnabled ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500'}`}
                title={
                  this.state.soundsEnabled
                    ? 'Silenciar sonidos'
                    : 'Activar sonidos'
                }
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {this.state.soundsEnabled ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15.536 8.464a5 5 0 010 7.072M17.95 6.05a8 8 0 010 11.9M6.5 8.5l4-4v15l-4-4H4a1 1 0 01-1-1v-5a1 1 0 011-1h2.5z"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
                    />
                  )}
                </svg>
              </button>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="text-gray-600">{this.formatTime(timer)}</span>
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                <span className="text-gray-600">{streak}</span>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="bg-white rounded-lg shadow-sm p-6">
            {restingRunning ? (
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  Tiempo de Descanso
                </h2>
                <div className="text-5xl font-bold text-green-500 mb-6">
                  {this.formatTime(restingTimer)}
                </div>
                <button
                  onClick={this.handleSkipRest}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300"
                >
                  Continuar
                </button>
              </div>
            ) : (
              <div className="flex flex-col md:flex-row md:space-x-6">
                {/* Image frame */}
                <div className="md:w-1/3 mb-6 md:mb-0">
                  <div className="aspect-w-1 aspect-h-1 bg-gray-100 rounded-lg overflow-hidden">
                    <img
                      src={questionData.image}
                      alt={
                        hasImage
                          ? 'Question illustration'
                          : 'No image available'
                      }
                      className={`object-cover w-full h-full ${
                        hasImage ? '' : 'opacity-20'
                      }`}
                    />
                  </div>
                </div>

                {/* Question & Answers */}
                <div className="md:w-2/3">
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">
                    {questionData.question}
                  </h2>
                  <div className="space-y-4 mb-6">
                    {questionData.answers.map((answer, index) => (
                      <button
                        key={index}
                        onClick={() => this.handleAnswerSelection(answer)}
                        className={`w-full py-3 px-4 rounded-md text-left transition-all duration-300 ${
                          showResult
                            ? selectedAnswer === answer
                              ? answer.isCorrect
                                ? 'bg-green-500 text-white'
                                : 'bg-red-500 text-white'
                              : 'bg-gray-100 text-gray-800'
                            : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
                        }`}
                      >
                        {answer.text}
                      </button>
                    ))}
                  </div>
                  {showResult && (
                    <div className="mt-6 p-4 bg-gray-50 rounded-md">
                      <p
                        className={`font-bold ${
                          selectedAnswer.isCorrect
                            ? 'text-green-500'
                            : 'text-red-500'
                        }`}
                      >
                        {selectedAnswer.isCorrect
                          ? '¡Correcto!'
                          : '¡Incorrecto!'}
                      </p>
                      {questionData.explanation && (
                        <p className="mt-2 text-gray-700">
                          {questionData.explanation}
                        </p>
                      )}
                      {questionData.videoRanges &&
                        questionData.videoRanges.length > 0 && (
                          <VideoExplanations
                            videoRanges={questionData.videoRanges}
                          />
                        )}
                    </div>
                  )}
                  {nextQuestionAvailable && (
                    <button
                      className="mt-6 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300"
                      onClick={this.loadNextQuestion}
                    >
                      Siguiente pregunta
                    </button>
                  )}
                </div>
              </div>
            )}
          </main>

          {/* Progress Dashboard - Same height as top header */}
          <div className="mt-6">{this.renderProgressDetails()}</div>

          {/* Chapters Grid */}
          {/* {this.state.showChapterGrid && (
            <div className="bg-white rounded-lg shadow-sm p-6 mt-6">
              {this.renderChaptersGrid()}
            </div>
          )} */}

          {/* Level Completion Modal */}
          {this.state.showLevelCompletionModal &&
            this.renderLevelCompletionModal()}

          {/* Snackbar */}
          {showSnackbar && (
            <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-md shadow-lg z-50 text-sm font-semibold animate-bounce">
              {snackbarMessage}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default InfinitePractice;
